import React from "react";

// Minimal inline markup renderer: **bold**, `code`, *italic*.
const RE = /(\*\*[^*]+\*\*|`[^`]+`|\*[^*]+\*)/g;

export function Inline({ text }) {
  if (!text) return null;
  const parts = [];
  let last = 0;
  let m;
  RE.lastIndex = 0;
  while ((m = RE.exec(text)) !== null) {
    if (m.index > last) parts.push({ type: "t", v: text.slice(last, m.index) });
    const tok = m[0];
    if (tok.startsWith("**")) parts.push({ type: "b", v: tok.slice(2, -2) });
    else if (tok.startsWith("`")) parts.push({ type: "c", v: tok.slice(1, -1) });
    else parts.push({ type: "i", v: tok.slice(1, -1) });
    last = RE.lastIndex;
  }
  if (last < text.length) parts.push({ type: "t", v: text.slice(last) });

  return (
    <>
      {parts.map((p, i) => {
        if (p.type === "b") return <strong key={i} className="font-bold text-[#1C2430]">{p.v}</strong>;
        if (p.type === "i") return <em key={i} className="italic">{p.v}</em>;
        if (p.type === "c") return <code key={i}>{p.v}</code>;
        return <React.Fragment key={i}>{p.v}</React.Fragment>;
      })}
    </>
  );
}
